$( document ).ready(function() {

  $('.navbar-toggler').click(function(){
    if ($('#bs4navbar').hasClass( "show" )){
      $('#bs4navbar').removeClass("collapse").addClass('collapsing').css('height', '270px');
      setTimeout(function () {      
        $('#bs4navbar').css('height', '').removeClass( "show" )
      }, 400);

      
    }
  })

  $(window).scroll(function(){
    $('nav').toggleClass('scrolled', $(this).scrollTop() > 50);
  });


  if($("#about-me-contact").length) {
    let aboutMeCord = $("#about-me-contact").offset().top - $("#about-me-contact").height();
    let productosCord = $("#productos").offset().top - $("#productos").height();

  
    $( document).scroll(function() {
      let currentPosition = $(document).scrollTop()
      if (currentPosition < aboutMeCord ) {
        $('.nav-link').removeClass('active')
        $(".menu-item-home a").addClass('active')
      }

      if (currentPosition > aboutMeCord ) {
        $('.nav-link').removeClass('active')
        $(".acerca-menu a").addClass('active')
      }
      if (currentPosition > productosCord ) {
        $('.nav-link').removeClass('active')
        $(".productos-menu a").addClass('active')
      }

    });
  }



  // Select all links with hashes
  $('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          let $target = $(target);
          let idTarget = target.attr('id')
          let idLink = event.currentTarget.getAttribute('href')
          let links = $('.nav-link')

          $('.nav-link').removeClass('active')
          if(idLink.includes(idTarget)){
            $(event.currentTarget).addClass('active')
          }

          $target.focus();
          if ($target.is(":focus")) {
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });
});
